module.exports = __webpack_public_path__ + "img/T1A_rc_19.4656eb9f.png";